import { addHours, addMinutes, format, formatDistance, isValid } from "date-fns";


export function standardDateFormat(date) {
  const inputDate = new Date(date);
  const indiaTime = addMinutes(addHours(inputDate, 5), 30);
  const outputDate = indiaTime ? format(indiaTime, "dd MMM, yyyy") : null;
  return date ? outputDate : "";
}

export function standardDateTimeFormat(date) {
  const inputDate = new Date(date);
  const indiaTime = addMinutes(addHours(inputDate, 5), 30);
  const outputDate = indiaTime ? format(indiaTime, 'dd MMM yyyy hh:mm a') : null;
  return date ? outputDate : "";
}
export function standardDateFormatDistance(
  date,
  addSuffix = true,
  shortForm = false
) {
  const inputDate = new Date(date);
  const indiaTime = addMinutes(addHours(inputDate, 5), 30);
  return indiaTime
    ? formatDistance(new Date(indiaTime), new Date(), {
      addSuffix,
    })
      .replace("hours", "hrs")
      .replace("hour", "hrs")
      .replace("minutes", "min")
      .replace("minute", "min")
      .replace("less than a min", "1 min")
    : "";
}

export function standardTimeFormat(time) {
  const inputDate = new Date(time);
  const indiaTime = addMinutes(addHours(inputDate, 5), 30);
  const outputDate = indiaTime ? format(indiaTime, 'hh:mm a') : null;
  return time ? outputDate : "";
}

export function isValidStartEndDate(startEndDate) {
  return !(
    !isValid(startEndDate?.fromDate) ||
    !isValid(startEndDate?.toDate) ||
    startEndDate?.toDate < startEndDate?.fromDate
  );
}

export function getDateFormatForApi(date) {
  return date ? format(new Date(date), "yyyy-MM-dd") : "";
}

export function convertUTCFromat(date) {
  return date ? new Date(date).toISOString() : "";
}

export function isCompleteDate(dateString) {
  const date = new Date(dateString);
  return !isNaN(date) && date.getDate() && date.getMonth() + 1 && date.getFullYear() >= 1900 && date.getFullYear() <= 2100;
}

